import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { SearchDrawerComponent } from "../search-drawer/search-drawer.component";
import { ServicesService } from '../my-profile/services.service';
import { ApiServicesService } from '../services/api-services.service';
import { FriendsCardComponent } from '../friends-card/friends-card.component';
import { CommonModule } from '@angular/common';
import { UserDetailsService } from '../services/user-details.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-search-tab',
  standalone: true,
  imports: [SearchDrawerComponent, FriendsCardComponent, CommonModule],
  templateUrl: './search-tab.component.html',
  styleUrl: './search-tab.component.css'
})
export class SearchTabComponent {
  private formDataSubscription!: Subscription;

  page: any = 1;
  limit: any = 10;
  private taskservices = inject(ServicesService);
  userData: any;
  formval: any;
  friends: any;
  responce = false;
  totalPages: any;
  formdata: any;
  is_load = false;
  no_friends = false;
  profile_completenes: any;
  constructor(private router: Router, private snackbarService: SnackbarService, private apiservices: ApiServicesService, private userdetails: UserDetailsService, private route: ActivatedRoute,) {
  }

  open_tab() {
    this.taskservices.toggleDrawer(true);
    // this.page=1
  }

  ngOnInit() {
    this.is_load = true;
    this.responce = true;
    this.friends = [];
    // this.page=1;
    // this.page = 1;
    // this.searchdata(this.formdata, this.page, this.limit);
    this.taskservices.searchdata$.subscribe(n => {
      if (n == null) {
        this.no_friends = true;
        this.friends = []; // Ensure it's an array
      } else {
        this.page = n?.currentPage;
        if (this.page == 1 && n.hasOwnProperty("user_data") && Array.isArray(n?.user_data)) {
          this.no_friends = false;
          this.friends = n.user_data;
        } else {
          this.friends = [...(this.friends || []), ...(n.user_data || [])]; // Ensure `this.friends` is an array
          this.no_friends = false;
        }
        this.totalPages = n.totalPages;
      }
      this.responce = false;
    });
    this.formDataSubscription = this.userdetails.formData$.subscribe((data) => {
      this.formdata = data;
      // console.log(data, "formdata for search");
    });


    this.userdetails.userdetails$.subscribe((userData) => {
      // console.log(userData)
      if (userData && userData.user) {
        this.profile_completenes = userData?.user?.profileCompleteness == 1 ? true : false;
        this.userData = userData;
      }
    });

  }


  ngAfterViewInit() {
    const formDataString = localStorage.getItem('formData');
    if (formDataString) {
      this.is_load = false
      this.formdata = JSON.parse(formDataString);
      this.searchdata(this.formdata, 1, this.limit);
      this.responce = false;
    } else {
      this.is_load = false
    }
  }

  ngOnDestroy(): void {
    if (this.formDataSubscription) {
      this.formDataSubscription.unsubscribe();
    }
  }
  searchdata(formdata: any, page: any, limit: any) {
    this.formval = formdata;

    const petsArray = this.formval.pets ? JSON.parse(this.formval.pets) : [];
    const seekingForArray = this.formval.seeking_for ? JSON.parse(this.formval.seeking_for) : [];

    const pets = petsArray.length === 0 ? null : petsArray;
    const seekingFor = seekingForArray.length === 0 ? null : seekingForArray;



    // Prepare the data for the API call
    this.apiservices
      .searchMembers(
        page,
        this.formval.gender,
        this.formval.seeking,
        this.formval.country,
        this.formval.state,
        this.formval.city,
        this.formval.age_from,
        this.formval.age_to,
        this.formval.isOnline,
        pets,         // Array of pet IDs
        seekingFor,   // Array of seeking_for IDs
        limit,
      )
      .subscribe({
        next: (data: any) => {
          if (data.status == 200) {
            const friends = data; // Assign data to friends
            this.taskservices.setSearchdata(friends); // Save data to the task service
            this.is_load = false; // Stop the loading indicator
            // console.log(friends.user_data,"friends");
          } else {
            this.no_friends = true;
          }
        },
        error: (error) => {
          console.error('Error fetching search data:', error); // Log the error for debugging
          this.is_load = false; // Stop the loading indicator
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: error.error.message,
              className: 'failed',
            }
          );
        },
      });
  }


  navigate() {
    this.router.navigate(["/my-profile", this.userData.user.username, 'edit_form']);

  }


  // @HostListener('window:scroll', ["$event"])
  // onScroll(event: Event): void {
  //   const target = event.target as Document;
  //   const scrollTop = target.scrollingElement?.scrollTop || 0;
  //   const innerHeight = window.innerHeight;
  //   const scrollHeight = target.scrollingElement?.scrollHeight || 0;
  //   if (
  //     innerHeight + scrollTop >= scrollHeight - 100 && !this.is_load && this.friends && (this.page < this.totalPages) && this.totalPages > 1) {
  //     this.is_load = true;
  //     this.page++;
  //     // console.log("page number in scroll",this.page)
  //     this.searchdata(this.formdata, this.page, this.limit);
  //   }
  // }



  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    if (!this.scrollContainer) return;

    const target = this.scrollContainer.nativeElement as HTMLElement;
    const rect = target.getBoundingClientRect(); // Get element position relative to the viewport
    const windowHeight = window.innerHeight;

    // Check if the element is visible near the bottom of the viewport
    if (rect.bottom <= windowHeight + 100 && !this.is_load && this.friends && (this.page < this.totalPages) && this.totalPages > 1) {
      // this.shimmer = true;
      // this.isLoading = true;
      this.is_load = true;
      this.page++;
      this.searchdata(this.formdata, this.page, this.limit);

    }
  }



}
